import { takeEvery, call, put, select } from 'redux-saga/effects';
import { combineReducers } from 'redux';
import get from 'lodash.get';
import request from '../api-utils/request';
import actionKey from '../utils/action-key';
import POSITION_TYPES from '../../constants/position-types';
import { showAlert } from './alert';

export const GET_USER_POSITION = 'manage-position/GET_USER_POSITION';
export const UPDATE_USER_POSITION = 'manage-position/UPDATE_USER_POSITION';

const noop = () => null;


const positionReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_USER_POSITION:
        case actionKey.init(GET_USER_POSITION):
            return {};
        case actionKey.success(GET_USER_POSITION):
        case actionKey.success(UPDATE_USER_POSITION):
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};

const loadingReducer = (state = null, action) => {
    switch (action.type) {
        case GET_USER_POSITION:
        case actionKey.init(GET_USER_POSITION):
            return true;
        case actionKey.success(GET_USER_POSITION):
        case actionKey.failure(GET_USER_POSITION):
            return false;
        default:
            return state;
    }
};

const updateLoading = (state = false, action) => {
    switch (action.type) {
        case UPDATE_USER_POSITION:
        case actionKey.init(UPDATE_USER_POSITION):
            return true;
        case actionKey.success(UPDATE_USER_POSITION):
        case actionKey.failure(UPDATE_USER_POSITION):
            return false;
        default:
            return state;
    }
};

const errorReducer = (state = null, action) => {
    switch (action.type) {
        case GET_USER_POSITION:
        case actionKey.init(GET_USER_POSITION):
        case actionKey.success(GET_USER_POSITION):
            return null;
        case actionKey.failure(GET_USER_POSITION):
            return action.error;
        default:
            return state;
    }
};

export default combineReducers({
    error: errorReducer,
    loading: loadingReducer,
    position: positionReducer,
    updateLoading,
});

export const getUserPositionAction = userId => ({
    type: GET_USER_POSITION,
    userId,
});

export const updateUserPositionAction = ({ userId, body, reject, resolve }) => ({
    type: UPDATE_USER_POSITION,
    userId,
    body,
    reject,
    resolve,
});

export function* rootSaga() {
    yield [
        takeEvery(UPDATE_USER_POSITION, updateUserPositionSaga),
        takeEvery(GET_USER_POSITION, getUserPositionSaga),
        takeEvery(actionKey.success(UPDATE_USER_POSITION), openSuccesModal),
    ];
}

export function* getUserPositionSaga({
    type,
    userId,
}) {
    yield call(request, {
        url: `/api/users/position/${userId}`,
        type,
    });
}

export function* updateUserPositionSaga({
    type,
    reject = noop,
    resolve = noop,
    userId,
    body,
}) {
    const res = yield call(request, {
        url: `/api/users/position/${userId}`,
        type,
        options: {
            method: 'PUT',
            body,
        },
        userId,
    });

    if (res.error && reject) {
        reject(res.error);
    } else if (!res.error && resolve) {
        resolve(res.payload);
    }
}

export function* openSuccesModal({
    payload: {
        positionType,
        companyPositions,
    },
    userId,
}) {
    const state = yield select();
    const positions = get(state, 'positions.companyPositionsList', []);
    yield put(showAlert({
        title: 'Changes Saved',
        type: 'success',
        button: 'Done',
        link: getBackLink({
            positionType,
            userPositions: companyPositions,
            positions,
            userId,
        }),
    }));
}


export const getBackLink = ({ positionType, userPositions = [], userId, positions = [] }) => {
    // eslint-disable-next-line camelcase
    const position = userPositions.find(positionId => positions.find(({ companyPositionID_PK }) => (
        companyPositionID_PK === Number(positionId) // eslint-disable-line camelcase
    )));
    if (Number(positionType) === POSITION_TYPES.EMPLOYEE || !position) {
        return `/result/${userId}`;
    }

    return `/candidate/${userId}/${position}`;
};



// WEBPACK FOOTER //
// ./src/client/redux/manage-position.js